import "./GetInTouch.module.css";
import Navigation from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import VisitTheStable from "./sections/VisitTheStable";
import Footer from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div>
      <Navigation />
      <GetInTouch />
      <VisitTheStable />
      <Footer />
    </div>;
}